<div class="dialog-content-wrapper">
  <div class="unsave-header">
    {{ 'event.add_chat_admins' | translate }}
  </div>
  <div class="add-chat-admins-modal m-0" mat-dialog-content>
    @if (users().length > 0) {
      <mat-form-field class="full-width">
        <mat-label>{{ 'event.chat_admins' | translate }}</mat-label>
        <mat-select multiple [(value)]="selectedUsers"
                    placeholder="{{ 'event.chat_admins_description' | translate }}">
          @for (user of users(); track user.id) {
            <mat-option [value]="user.id">
              {{ user.firstName + ' ' + user.lastName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else {
      <div>
        <span>{{ 'event.no_admins' | translate }}</span>
      </div>
    }

  </div>

  <div mat-dialog-actions class="m-0 p-10 unsave-footer" fxLayout="row" fxLayoutAlign="end center">
    <button class="save-button" mat-button (click)="addAdmins()" [disabled]="!selectedUsers.length">
      <span>{{ 'button.confirm' | translate }}</span>
    </button>
    <button mat-button (click)="dialogRef.close()">
      <span>{{ 'button.cancel' | translate }}</span>
    </button>

  </div>
</div>
